import React from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import moment from "moment";
import { useParams } from "react-router-dom";

import { CREATE_GIFT } from "actions/ActionTypes";
import history from "components/common/navigation/AppHistory";
import { postApi } from "actions/SendActions";
import { notifError } from "actions/FlashMessageActions";
import GiftAdminForm from "components/gift/GiftAdminForm";

import "css/admin/smartlist.scss";

export function GiftAdminCreateUI({ onSubmit, onError, token, t }) {
  const { projectSlug } = useParams();

  const freecopy = {
    limit_date: null,
    month_duration: 1,
    lang: "en",
  };

  const onCreate = (item) => {
    // Format model for saving

    const errorMessages = itemIsValide(item);
    if (errorMessages.length === 0) {
      onSubmit(item, token, projectSlug, t);
    } else {
      onError(t("editor-errors:saveGiftError"), errorMessages);
    }
  };

  const itemIsValide = (item) => {
    const errorMessages = [];

    if (!item.email) {
      errorMessages.push(t("editor-errors:emailNull"));
    }

    if (!item.limit_date) {
      errorMessages.push(t("editor-errors:limiteDateNull"));
    }

    if (item.limit_date && moment(item.limit_date).isBefore(moment())) {
      errorMessages.push(t("editor-errors:limiteMustBeInFuture"));
    }

    return errorMessages;
  };

  return <GiftAdminForm item={freecopy} onSubmit={onCreate} editMode={false} />;
}

GiftAdminCreateUI.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { token } = state.loginReducer;

  return {
    token,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onSubmit(data, token, projectSlug, t) {
    dispatch(
      postApi({
        endpoint: "/api/offer/v3/admin/gifts/create",
        type: CREATE_GIFT,
        headers: [
          {
            key: "xx-ok-project",
            value: projectSlug,
          },
        ],
        token,
        data,
        error: t("saveGiftError"),
        callback: () => {
          history.push("/gift");
        },
      }),
    );
  },
  onError(error, details) {
    dispatch(notifError(error, details));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("editor-gift", "editor-errors")(GiftAdminCreateUI));
